module.exports = __webpack_public_path__ + "static/media/Jewel Thief.0dd2ad7a.jpg";